// export const shareResolveOptimistic = async (
//   apiUrl,
//   organization,
//   branch,
//   sheetId,
//   value,
//   setSheets
// ) => {

//   if (!branch) {
//     console.error("Branch is missing!");
//     return;
//   }

//   const updateState = (val) => {
//     setSheets(prev => {
//       const list = Array.isArray(prev) ? prev : [];

//       return list
//         .filter(Boolean)
//         .map(s => {

//           if (!s?.raw?.sheet_id) return s;

//           return s.raw.sheet_id === sheetId
//             ? {
//                 ...s,
//                 raw: {
//                   ...s.raw,
//                   html_css_published: val === 1,
//                   solution_published: val === 1,
//                   angular_published: val === 1,
//                   react_published: val === 1
//                 }
//               }
//             : s;
//         });
//     });
//   };
//   updateState(value);

//   try {

//     // 🔥 Safe URL build
//     const url = [
//       apiUrl,
//       "ti/api/v1",
//       organization,
//       branch,
//       "sharesolution",
//       sheetId
//     ].filter(Boolean).join("/");

//     const resp = await fetch(url, {
//       method: "PUT",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ share: value })
//     });

//     if (!resp.ok) throw new Error();

//   } catch (err) {
//     updateState(value === 1 ? 0 : 1);
//   }
// };
const getCookie = (name) => {
  const cookie = document.cookie
    .split("; ")
    .find(row => row.startsWith(`${name}=`));

  return cookie
    ? decodeURIComponent(cookie.split("=").slice(1).join("="))
    : null;
};

export const shareResolveOptimistic = async (
  apiUrl,
  organization,
  branch,
  sheetId,
  value,
  setSheets
) => {
  if (!branch) {
    console.error("Branch is missing!");
    return;
  }

  const updateState = (val) => {
    setSheets(prev => {
      const list = Array.isArray(prev) ? prev : [];

      return list
        .filter(Boolean)
        .map(sheet => {
          if (!sheet?.raw?.sheet_id) return sheet;

          return sheet.raw.sheet_id === sheetId
            ? {
                ...sheet,
                raw: {
                  ...sheet.raw,
                  html_css_published: val === 1,
                  solution_published: val === 1,
                  angular_published: val === 1,
                  react_published: val === 1
                }
              }
            : sheet;
        });
    });
  };

  updateState(value);

  try {
    const url = [
      apiUrl?.replace(/\/$/, ""),
      "ti/api/v1",
      organization,
      branch,
      "sharesolution",
      sheetId
    ]
      .filter(part => part !== undefined && part !== null)
      .join("/");

    const csrfToken = getCookie("csrftoken");

    const response = await fetch(url, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...(csrfToken && {
          "X-CSRFToken": csrfToken
        })
      },
      body: JSON.stringify({
        share: value
      })
    });

    if (!response.ok) {
      const responseBody = await response.text();

      console.error("Share solution request failed:", {
        status: response.status,
        url,
        response: responseBody
      });

      throw new Error(`HTTP ${response.status}`);
    }
  } catch (error) {
    console.error("Could not update solution visibility:", error);
    updateState(value === 1 ? 0 : 1);
  }
};